import { forwardRef } from 'react';
import PropTypes from 'prop-types';

import Colors from '../utils/colors';

const BestChoiceLabelCircledIcon = forwardRef(
  ({ size = 40, className = '', ...props }, ref) => (
    <svg
      {...props}
      className={className}
      ref={ref}
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="20" fill={Colors.tertiary} />
      <path
        d="M28.9807 15.8893C28.9807 10.9632 24.9553 6.95605 20.0067 6.95605C15.2968 6.95605 11.4283 10.5818 11.0641 15.1766C11.0453 15.4142 11.0327 15.6455 11.0327 15.8893C11.0327 16.1331 11.0453 16.3644 11.0641 16.6019C11.2902 19.4525 12.8665 21.9281 15.1586 23.3972H11.0327V24.1098C11.0327 29.0359 15.0581 33.043 20.0067 33.043C24.7104 33.043 28.5851 29.4172 28.9493 24.8225C28.9682 24.5849 28.9807 24.3536 28.9807 24.1098C28.9807 23.866 28.9682 23.6347 28.9493 23.3972C28.7233 20.5465 27.147 18.071 24.8548 16.6019H28.9807V15.8893ZM12.4959 16.6019H19.2908V23.3659C15.6987 23.0283 12.8351 20.1714 12.4959 16.6019ZM20.0067 31.6177C16.0881 31.6177 12.8602 28.6295 12.4959 24.8225H27.5175C27.1533 28.6295 23.9254 31.6177 20.0067 31.6177ZM27.5175 23.3972H20.7226V16.6332C24.3085 16.9707 27.1784 19.8214 27.5175 23.3972ZM12.4959 15.1766C12.8539 11.3695 16.0881 8.38137 20.0067 8.38137C23.9254 8.38137 27.1533 11.3695 27.5175 15.1766H12.4959Z"
        fill={Colors.dark}
      />
    </svg>
  )
);

BestChoiceLabelCircledIcon.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string
};

export default BestChoiceLabelCircledIcon;
